module.exports = __webpack_public_path__ + "img/momo.ee494ffd.png";